// ANGULAR IMPORTS
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

// EXTERNAL DEPENDENCIES
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import moment from 'moment';

// SERVICES
import { TokenStorageService } from '../../../../../../../app/state/core/services/token-storage/token-storage.service';
import { AuthStoreService } from '../../../../../../../app/state/modules/auth/auth-store.service';
import { ShiftInfoMainService } from '../../../../../../modules/main/shift-info/services/shift-info-main.service';
import { UserStoreService } from '../../../../../../state/modules/user/user-store.service';
import { SignalRService } from '../../../../../../core/services/signal-r.service';
import { TimesheetStoreService } from '../../../../../../state/modules/timesheet/timesheet-store.service';
import { AmplitudeService } from '../../../../../../core/services/amplitude.service';
import { UserService } from '../../../../../../state/modules/user/services/user.service';
import { IntercomService } from '../../../../../../../app/state/core/services/intercom-chat-service/intercom-chat-io.service';

// COMPONENTS
import { BusinessSettingComponent } from '../../../../../../modules/main/business/components/business-setting/business-setting.component';
import { ChangePasswordComponent } from '../../../../../../modules/main/business/components/change-password/change-password.component';
import { EmployeeActionComponent } from '../../../../../../modules/main/employee/components/employee-action/employee-action.component';
import { KioskPinComponent } from '../../../../../../modules/main/employee/components/kiosk-pin/kiosk-pin.component';
import { ClientActionComponent } from '../../../../../../modules/main/employee/components/client-action/client-action.component';
import { ModalBaseClass } from '../../../../../../../app/modules/shared/components/modals/base_class/modal-base-class';

// CONSTANTS
import { AUTH_METHOD_CONSTANTS } from '../../../../../../../app/constants/ngrx-store/auth';
import { ROUTE_CONSTANTS } from '../../../../../../../app/constants/route';
import { TimesheetEnum } from '../../../../../../constants/lookup/timesheet/timesheet-status.enum';
import { API_METHOD_CONSTANTS } from '../../../../../../constants/ngrx-store/core';
import { USER_METHOD_CONSTANT } from '../../../../../../constants/ngrx-store/user';
import { FORM_CONSTANTS } from '../../../../../../modules/main/employee/components/employee-action/employee-action.constant';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../../constants/ngrx-store/timesheet';
import { Billing } from '../../../../../../constants/enum/common/Billing-tabs.enum';
import { Role } from '../../../../../../constants/enum/common/role-enum';
import { AMPLITUDE_EVENT } from '../../../../../../core/services/amplitude.service';
import { PERMISSION_CONSTANT } from '../../../../../../constants/permission';
import { PERMISSIONV2 } from '../../../../../../constants/permissionv2/role-permission';

// UTILITIES
import { LocalStorageUtil } from '../../../../../../core/utils/local-storage-util';
import { DateUtil } from '../../../../../../core/utils/date-util';


declare var Tawk_API: any;

@Component({
  standalone: false,
  selector: 'kt-user-profile2',
  templateUrl: './user-profile2.component.html',
  styleUrls: ['./user-profile2.component.scss'],
})
export class UserProfile2Component extends ModalBaseClass implements OnInit, OnDestroy {
  // Public properties
  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;
  permissionConstant = PERMISSION_CONSTANT;

  user$: any = {};
  sub: Subscription[] = [];
  shiftInfo = null;
  timesheet = null;
  isAdmin = null;
  timeElapsed = signal('');
  interval = null;
  currentStatus = TimesheetEnum.NONE;
  timesheetenumRef = TimesheetEnum;
  unreadNotifications = signal(0);
  // gettingStartedInfo = null;
  displayFreshchatWidget = false;
  permissionV2 = PERMISSIONV2

  constructor(
    private router: Router,
    public modalService: NgbModal,
    private userStoreService: UserStoreService,
    private userService: UserService,
    private shiftMainService: ShiftInfoMainService,
    private timesheetStoreService: TimesheetStoreService,
    private authStoreService: AuthStoreService,
    private signalRService: SignalRService,
    private tokenStorageServie: TokenStorageService,
    private interCometService: IntercomService,
    private cdr: ChangeDetectorRef
  ) {
    super(modalService);
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */
  _userData = { pic: '../../../../../../../assets/media/users/100_1.jpg' };

  showProductMap() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_WHATS_NEW, null);
    (window as any).Productstash.show();
  }
  setTimeElapsed() {
    if (this.timesheet && this.timesheet.timesheet_actual_start_date) {
      // parse start date in its timezone
      const start = moment.tz(this.currentStatus === this.timesheetenumRef.ONBREAK ? this.timesheet.timesheet_active_break_start_date : this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss', this.timesheet.timesheet_fk_location_timezone);

      // current time in same timezone
      const now = DateUtil.getCurrentDateTimeWithLocationTimezone(this.timesheet.timesheet_fk_location_timezone);

      const seconds = Math.abs(start.diff(now, 'seconds'));

      // const seconds = Math.abs(moment(this.currentStatus === this.timesheetenumRef.ONBREAK ? this.timesheet.timesheet_active_break_start_date : this.timesheet.timesheet_actual_start_date, 'YYYY-MM-DDTHH:mm:ss').diff(moment(), 'seconds', false));
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor(seconds / 60).toString().padStart(2, '0');
      if (+hours) {
        this.timeElapsed.set(`${hours} Hrs:  ${(+minutes) - ((+hours) * 60)} Mins`);
      } else {
        this.timeElapsed.set(`${(minutes)} Mins`);

      }
    }
  }

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.authStoreService.selectUser();

    this.dispatchGetShiftInfo();
    this.dispatchGetNotifications();
    this.sub.push(this.shiftMainService.refresh().subscribe(value => {
      this.dispatchGetShiftInfo();
    }));
    this.sub.push(this.shiftMainService.getShowSidebarListener().subscribe(value => {
      if (!value && this.shiftMainService.isSideBarOpened()) {
        this.dispatchGetShiftInfo();
      }
    }));
    this.sub.push(this.signalRService.notification$.subscribe((value) => {
      if (value) {
        // console.log(value);
        this.dispatchGetNotifications();
      }
    }));
    this.sub.push(this.shiftMainService.getshowNotificationSidebarListener().subscribe(value => {
      if (!value) {
        this.dispatchGetNotifications();
      }
    }));

    this.initFreshchatMethod();
    this.isAdmin = Role.System_Administrator === LocalStorageUtil.getUserRole();
  }

  setScheduleInfo(data) {
    if (data.success && data.data.data) {
      const timesheetInfo = data.data.data.timesheet_info;
      this.timesheet = timesheetInfo;
      if (this.timesheet) {
        this.currentStatus = this.timesheet.timesheet_shift_status;
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.setTimeElapsed();

        this.interval = setInterval(() => {
          this.setTimeElapsed();
        }, 60000);

      } else {
        this.currentStatus = TimesheetEnum.NONE;
      }

    }
    // Runs in an ngrx callback; plain prop mutations above won't tick CD in
    // ng21 hybrid — mark dirty so the topbar shift button reflects new status.
    this.cdr.markForCheck();
  }
  showSidebar(event) {
    event.stopPropagation();
    this.shiftMainService.showSidebar(true);
  }
  async getCallBack(res) {
    await this.interCometService.onUserLogout()
    this.tokenStorageServie.clear();
    this.router.navigate([ROUTE_CONSTANTS.CONTAINER.AUTH, ROUTE_CONSTANTS.AUTH.LOGIN]);
  }

  myProfileClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_MY_PROFILE, null);
    const employeeId = LocalStorageUtil.getEmployeeId();
    const loginRole = LocalStorageUtil.getUserRole();
    if (loginRole === Role.Client) {
      this.openPopUp(ClientActionComponent, { data: { employee_id: employeeId }, currentStep: FORM_CONSTANTS.PERSONAL_DETAIL }, { centered: true, size: 'xl', keyboard: true, backdrop: 'static' });
    } else {
      this.openPopUp(EmployeeActionComponent, { data: { employee_id: employeeId }, currentStep: FORM_CONSTANTS.PERSONAL_DETAIL }, { centered: true, size: 'xl', keyboard: true, backdrop: 'static' });
    }
  }

  kioskClickHandler() {
    this.openPopUp(KioskPinComponent, { userId: LocalStorageUtil.getUserId() }, { centered: true, size: 'md', keyboard: true, backdrop: 'static' });
  }

  switchBusinessClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_SWITCH_BUSINESS, null);
    this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.CHANGE_BUSINESS]);
  }

  changePasswordHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_CHANGE_PASSWORD, null);
    this.openPopUp(ChangePasswordComponent, null, { centered: true, size: 'md', keyboard: true, backdrop: 'static' });

  }

  billingClickHandler() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_BILLING, null);
    this.router.navigate([
      ROUTE_CONSTANTS.CONTAINER.BUSINESS,
      ROUTE_CONSTANTS.BUSINESS.SETTING_ONLY, LocalStorageUtil.getBusinessGuid()],
      { queryParams: { activeTab: Billing.Billing } }
    );
  }


  dispatchGetShiftInfo() {
    this.timesheetStoreService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.TIMESHEET_INFO,
      method: API_METHOD_CONSTANTS.GET_BY_ID,
      callback: this.setScheduleInfo.bind(this),
    });
  }


  /**
   * Log out handler
   */
  logout() {
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_SIGN_OUT, null);
    this.authStoreService.dispatchLogout({
      callback: this.getCallBack.bind(this),
      data: {},
      module: AUTH_METHOD_CONSTANTS.LOGOUT,
    });
  }
  showNotificatinBar(event) {
    event.stopPropagation();
    new AmplitudeService().logEvent(AMPLITUDE_EVENT.BUSINESS_MENU_NOTIFICATION, null);
    this.shiftMainService.showNotificationSidebar(true);
  }
  /**
   *
   * Navigates to change Business Screen
   */
  changeBusinessHandler() {
    this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.CHANGE_BUSINESS]);

  }

  openBusinessSetting() {
    this.openPopUp(BusinessSettingComponent, null, { centered: true, size: 'xl', keyboard: true, backdrop: 'static' });
  }
  setnotifications(data) {
    if (data.success) {
      this.unreadNotifications.set(data.data.data.user_notification_count.user_notification_unread_count);
    }
  }

  dispatchGetNotifications() {
    this.userStoreService.dispatchUserCommon({
      data: { page_number: 1, page_size: 10 },
      callback: this.setnotifications.bind(this),
      module: USER_METHOD_CONSTANT.USER_NOTIFICATION_COUNT,
      method: API_METHOD_CONSTANTS.INSERT,
    });
  }



  // Freshchat widget portion start
  initFreshchatMethod() {
    this.sub.push(this.interCometService.isDisplayIntercomWidget$.subscribe(value => {
      this.displayFreshchatWidget = value;
    }));

    // Open if it's already open
    if (this.tokenStorageServie.getChatWidgetStatus()) {
      this.openChat();
    }
  }

  openChat() {
    this.interCometService.openChat();
  }

  closeChat(clearStorage: boolean = false) {
    this.interCometService.closeChat(clearStorage);
  }
  // Freshchat widget portion end

  ngOnDestroy() {
    // Added for Freshchat widget
    this.interCometService && this.interCometService.closeChat();

    // Clear interval if it exists
    if (this.interval) {
      clearInterval(this.interval);
    }

    // Unsubscribe from all subscriptions to avoid memory leaks
    if (this.sub) {
      this.sub.forEach(subscription => subscription.unsubscribe());
    }
  }
}
